import { Typography, Box, CardMedia } from '@material-ui/core'
import ErrorStateImage from './ErrorStateImage.png'
import useStyles from './ErrorMessage.styles'

const ErrorMessage = () => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <CardMedia
        component='img'
        image={ErrorStateImage}
        alt='Unable to load page'
        aria-label='Unable to load page'
        title='Unable to load page'
        className={classes.image}
      />
      <Typography
        gutterBottom
        variant='h1'
        color='textSecondary'
        className={classes.title}
      >
        Uh Oh!
      </Typography>
      <Typography variant='h6' color='textSecondary'>
        We are unable to load this page. If you still have an issue, please
        reach out to{' '}
        <a
          href='mailto:success@resilia.com'
          target='_blank'
          rel='noopener noreferrer'
        >
          support@resilia.com
        </a>{' '}
        for additional assistance.
      </Typography>
    </Box>
  )
}

export default ErrorMessage
